/* ============
 * Vue i18n
 * ============
 *
 * Internationalization plugin of Vue.js.
 *
 * https://kazupon.github.io/vue-i18n/
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import browserLocale from 'browser-locale';
import messages from '@/locale/defaultMessages';
import numberFormats from '@/locale/numberFormats';

Vue.use(VueI18n);

const fallbackLocale = 'en';
let locale = fallbackLocale;
const lang = browserLocale()
  .toLowerCase()
  .substring(0, 2);
const supportedLangs = Object.keys(messages);
if (supportedLangs.indexOf(lang) !== -1) {
  locale = lang;
}

export const i18n = new VueI18n({
  locale,
  fallbackLocale,
  messages,
  numberFormats,
});

const I18nUtils = {
  install(Vue, { i18n }) {
    // translate optional
    Vue.prototype.$to = msg => {
      if (i18n.te(msg)) return i18n.t(msg);
      return msg;
    };

    // translate mapping (if simplify is true, convert case to lower and replace all non-alphanumeric characters to underscores)
    Vue.prototype.$tm = (prefix, name, simplify = false, params = undefined, method = 't') => {
      const key =
        prefix +
        (simplify
          ? String(name)
              .replace(/\W/g, '_')
              .toLowerCase()
          : name);
      if (i18n.te(key)) return i18n[method](key, params);
      return name;
    };

    // translate optional fallback
    Vue.prototype.$tf = (msg, fallback = '') => {
      if (i18n.te(msg)) return i18n.t(msg);
      if (typeof fallback === 'function') return fallback();
      return fallback;
    };

    // translate tooltip
    Vue.prototype.$tt = msg => {
      const key = `${msg}_tooltip`;
      if (i18n.te(key)) return i18n.t(key);
    };
  },
};

Vue.use(I18nUtils, {
  i18n,
});

export default {
  i18n,
};
